import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'core/common/i18n'
import { Button, Box } from 'core/components/Core'

function ProductUploadFooter({
  closeModal,
  isPossibleSelect,
  isSelectionEnabled,
  onConfirmSelect,
}) {
  return (
    <Box p={2} justifyContent="flex-end" display="flex" mr={2}>
      {closeModal && (
        <Box mr={1}>
          <Button variant="contained" size="medium" color="default" onClick={closeModal}>
            {i18n.t('product.productUpload.close')}
          </Button>
        </Box>
      )}
      {!!isPossibleSelect && (
        <Button
          variant="contained"
          disabled={!isSelectionEnabled}
          size="medium"
          color="primary"
          onClick={() => onConfirmSelect()}
        >
          {i18n.t('product.productUpload.confirmSelect')}
        </Button>
      )}
    </Box>
  )
}

ProductUploadFooter.defaultProps = {
  closeModal: () => null,
  isPossibleSelect: false,
  isSelectionEnabled: false,
}

ProductUploadFooter.propTypes = {
  onConfirmSelect: PropTypes.func.isRequired,
  closeModal: PropTypes.func,
  isPossibleSelect: PropTypes.bool,
  isSelectionEnabled: PropTypes.bool,
}

export default ProductUploadFooter
